import Vue from 'vue'
import Vuex from 'vuex'
import "@/types"

import auth from './auth'
import views from './views'
import sequence from './createSequence'

Vue.use(Vuex)

const _user:User = {
  email: null,
  id: null,
  name: null
}

export default new Vuex.Store({

  state: {
    user: _user,
    // views: _views,
    cameras: {
      items: []
    },
    client: {},
    clients: {
      items: []
    },
    edits: {
      items: []
    },
    partner: {},
    projects: {
      items: []
    },
    schemas: {},
    users: {
      items: []
    }
  },

  mutations: {
    setClient(state, client) {
      state.client = client
    },
    setSchemas (state, schemas) {
      state.schemas = schemas
    },
    setUser (state, user) {
      user ? state.user = user : state.user = _user
    }
  },

  actions: {
    setClient({commit}, client) {
      commit('setClient', client)
    },
    setSchemas({ commit }, schemas) {
      commit('setSchemas', schemas)
    },
    updateUser({ commit }, user) {
      commit('setUser', user)
    }
  },
  
  getters: {
    user({ user }) {
      const { id, name, email } = user
      return { id, name, email }
    }
  },

  modules: {
    auth, views, sequence
  }
})
